import { render, staticRenderFns } from "./JoinedTutors.vue?vue&type=template&id=117e3edc"
import script from "./JoinedTutors.vue?vue&type=script&lang=js"
export * from "./JoinedTutors.vue?vue&type=script&lang=js"
import style0 from "./JoinedTutors.vue?vue&type=style&index=0&id=117e3edc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports